import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CompetitionResultRow } from "@/components/CompetitionResultRow";
import { useCategories } from "@/context/CategoriesContext";
import { Printer, Trophy } from "lucide-react";

export default function Official() {
  const { ALL_CATEGORIES, CATEGORY_LABEL } = useCategories();
  const [rankings, setRankings] = useState({});
  const [openCat, setOpenCat] = useState("");
  useEffect(() => { if (!ALL_CATEGORIES.includes(openCat)) setOpenCat(ALL_CATEGORIES[0] || ""); }, [ALL_CATEGORIES, openCat]);

  const load = () => api.get("/rankings").then((r) => setRankings(r.data || {})).catch(() => {});
  useEffect(() => { load(); }, []);

  const printCat = () => window.print();

  return (
    <div>
      <div className="flex items-end justify-between mb-6 flex-wrap gap-3">
        <div>
          <h1 className="font-display font-black text-3xl tracking-tight" data-testid="competition-round-title">Competition Round</h1>
          <p className="text-[#7A7D8C] mt-1 text-sm" data-testid="single-solve-instructions">Enter one competition solve in seconds. The recorded time determines placement. Leave the time blank or select DNF / DNS if there is no valid solve. Historical multi-solve results are preserved.</p>
        </div>
        <button onClick={printCat} data-testid="print-btn" className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-slate-200 text-sm font-semibold hover:border-[#FF9F1C]"><Printer className="w-4 h-4" /> Print rankings</button>
      </div>

      <div className="flex gap-2 flex-wrap mb-6">
        {ALL_CATEGORIES.map((c) => (
          <button key={c} onClick={() => setOpenCat(c)} data-testid={`tab-${c}`} className={`px-4 py-2 rounded-full text-sm font-semibold border ${openCat === c ? "bg-[#FF9F1C] text-white border-[#FF9F1C] shadow-[0_8px_20px_rgb(255,159,28,0.3)]" : "bg-white border-slate-200 hover:border-[#FF9F1C]"}`}>{CATEGORY_LABEL[c]} <span className="ml-2 text-xs opacity-70">{rankings[c]?.length ?? 0}</span></button>
        ))}
      </div>

      <CategoryTable category={openCat} rows={rankings[openCat] || []} onSaved={load} />
    </div>
  );
}

function CategoryTable({ category, rows, onSaved }) {
  const { CATEGORY_LABEL } = useCategories();
  return (
    <div className="bg-white rounded-2xl border border-slate-100 overflow-hidden">
      <div className="px-6 py-4 border-b border-slate-100 flex items-center gap-3">
        <Trophy className="w-4 h-4 text-[#FF9F1C]" />
        <h2 className="font-display font-bold">{CATEGORY_LABEL[category]}</h2>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid={`official-table-${category}`}>
          <thead>
            <tr className="bg-[#FDFFFC] text-[#7A7D8C] text-xs uppercase tracking-wider">
              <th className="text-left px-4 py-3 w-14">Rank</th>
              <th className="text-left px-4 py-3">Name</th>
              <th className="text-left px-2 py-3">Solve time (seconds)</th>
              <th className="text-left px-4 py-3">Result</th>
              <th className="text-left px-4 py-3">DNF / DNS</th>
              <th className="text-left px-4 py-3">Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={6} className="p-8 text-center text-[#7A7D8C]">No competitors assigned to this category yet.</td></tr>
            ) : rows.map((r, i) => <CompetitionResultRow key={r.id} row={r} rank={r.official_dnf || r.official_average == null ? "—" : i + 1} onDone={onSaved} />)}
          </tbody>
        </table>
      </div>
    </div>
  );
}

